import { AcceptCompanyWithdrawalMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const acceptCompanyWithdrawalHandler =
  // migrated code
  graphql.mutation<AcceptCompanyWithdrawalMutation>(
    "acceptCompanyWithdrawal",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          acceptCompanyWithdrawal: {
            result: true,
          },
        },
      });

      // return HttpResponse.json(
      //   ctx.data({})
      // ctx.errors([
      //   {
      //     extensions: {
      //       code: ErrorCode[ErrorCode.BUSINESS_LOAN_IS_IN_USE],
      //     },
      //   },
      // ])
    }
  );
